module.exports = __webpack_public_path__ + "static/media/exclamation.b497d8b6.svg";